var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DinTypography } from "../../modules/ai-report-v2/components/styled";
import { Stack } from 'fbm-ui/lib/mui';
var AiHeaderTitle = function (_a) {
    var name = _a.name;
    return (_jsxs(Stack, __assign({ display: "inline-flex", direction: "row", spacing: 1, sx: {
            pl: 3,
            height: 40,
            color: '#009D56',
            background: 'url(//webcdn.fbmms.cn/assets/yt-b/yf2BqqIlr8Xtb8N2o44t1) no-repeat center center',
            backgroundSize: 'contain',
            width: 24 + (56 / 4) * name.length + 84,
            dispoly: 'flex',
            alignItems: 'center',
        } }, { children: [_jsx("img", { src: "//webcdn.fbmms.cn/assets/7Vj-/P5j2FTojTq7M3W7clK6tX", alt: "", style: { width: 32, height: 20 } }), _jsx(DinTypography, __assign({ variant: "h6", color: "inherit" }, { children: name }))] })));
};
export default AiHeaderTitle;
